<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">{{ company.name }}</h4>
  <button type="button" class="btn-modal-close" aria-label="Close" (click)="closeModal()">
    <span class="material-icons-outlined">close</span>
  </button>
</div>

<div class="modal-body">

  <img [src]="company.image | companyImage" class="modal-company-logo" [alt]="company.name" *ngIf="company.image">

  <ng-container *ngIf="company.description">
    <p class="modal-section-title" style="margin-top: 0">À propos</p>
    <p style="font-size: 0.9rem; color: #555; line-height: 1.65">{{ company.description }}</p>
  </ng-container>

  <ng-container *ngIf="company.actions && company.actions.length > 0">
    <p class="modal-section-title">Les actions</p>
    <div>
      <div class="modal-action-item" *ngFor="let action of company.actions">{{ action.content }}</div>
    </div>
  </ng-container>

  <ng-container *ngIf="company.motivation">
    <p class="modal-section-title">Engagement avec Opale.care</p>
    <p style="font-size: 0.9rem; color: #555; line-height: 1.65">{{ company.motivation }}</p>
  </ng-container>

</div>

<div class="modal-footer d-flex justify-content-between align-items-center">
  <div class="d-flex gap-2">
    <a href="{{ company.website }}" class="social-link" target="_blank" *ngIf="company.website">
      <img src="assets/images/social/website.svg" alt="site web {{ company.name }}">
    </a>
  </div>
  <button type="button" class="btn btn-info text-white fw-semibold px-4" (click)="closeModal()">Fermer</button>
</div>
